import styled from "styled-components";
import { colors, typography } from "@streeteasy/design-system";

const { TEXT_SECONDARY } = colors;

export const Text = styled(typography.Caption)`
  color: ${TEXT_SECONDARY};
  margin-bottom: 20px;
`;
